import React, { useEffect, useMemo, useState } from 'react';
import MyButton from '../../../components/MyButton';
import { EVENT_FIELDS, FIELD_TYPES, isFieldLocked } from '../constants';
import EventFieldEditor from './EventFieldEditor';

function emptyValueForField(field) {
  switch (field.type) {
    case FIELD_TYPES.languages:
    case FIELD_TYPES.photos:
    case FIELD_TYPES.holdingDates:
      return field.type === FIELD_TYPES.holdingDates ? [''] : [];
    case FIELD_TYPES.category:
    case FIELD_TYPES.city:
    case FIELD_TYPES.coordinates:
      return null;
    case FIELD_TYPES.isForAllLanguages:
      return true;
    default:
      return '';
  }
}

function BulkToolbar({
  stats,
  config,
  categories,
  countries,
  languages,
  creatingProgress,
  onSelectAll,
  onSelectNone,
  onCreateSelected,
  onRemoveSelected,
  onRemoveCreated,
  onApplyToSelected,
}) {
  const editableFields = useMemo(
    () => EVENT_FIELDS.filter((field) => !isFieldLocked(field, config)),
    [config],
  );
  const lockedFields = useMemo(
    () => EVENT_FIELDS.filter((field) => isFieldLocked(field, config)),
    [config],
  );
  const [fieldKey, setFieldKey] = useState('');
  const [value, setValue] = useState('');
  const field = editableFields.find((item) => item.key === fieldKey) || null;

  useEffect(() => {
    setValue(field ? emptyValueForField(field) : '');
  }, [fieldKey]);

  return (
    <div className="bulk_offers_toolbar">
      <div className="bulk_offers_toolbar_top">
        <div className="bulk_offers_stats">
          <span>{`Всего: ${stats.total}`}</span>
          <span>{`Выбрано: ${stats.selected}`}</span>
          <span className="ready">{`Готово: ${stats.ready}`}</span>
          <span className="invalid">{`С ошибками: ${stats.invalid}`}</span>
          <span className="created">{`Создано: ${stats.created}`}</span>
        </div>
        <div className="bulk_offers_toolbar_buttons">
          <MyButton text="Выбрать все" onClick={onSelectAll} secondary className="bulk_offers_toolbar_button" />
          <MyButton text="Снять выбор" onClick={onSelectNone} secondary className="bulk_offers_toolbar_button" />
          <MyButton text="Создать выбранные" onClick={onCreateSelected} disabled={!stats.selected} loading={Boolean(creatingProgress)} className="bulk_offers_toolbar_button" />
          <MyButton text="Убрать выбранные" onClick={onRemoveSelected} disabled={!stats.selected} secondary className="bulk_offers_toolbar_button bulk_offers_toolbar_button_danger" />
          <MyButton text="Убрать созданные" onClick={onRemoveCreated} disabled={!stats.created} secondary className="bulk_offers_toolbar_button" />
        </div>
      </div>

      {creatingProgress ? <p className="bulk_offers_toolbar_progress">{creatingProgress}</p> : null}

      <div className="bulk_offers_toolbar_apply">
        <div className="bulk_offers_toolbar_apply_head">
          <p className="bulk_offers_toolbar_apply_title">Редактировать поле у выбранных</p>
          <select
            className="bulk_offers_select bulk_offers_select_field"
            value={fieldKey}
            onChange={(e) => setFieldKey(e.target.value)}
          >
            <option value="">— Выберите поле —</option>
            {editableFields.map((item) => (
              <option key={item.key} value={item.key}>{item.label}</option>
            ))}
          </select>
          <MyButton
            text={`Применить к выбранным (${stats.selected})`}
            onClick={() => field && stats.selected && onApplyToSelected(field, value)}
            disabled={!field || !stats.selected}
            className="bulk_offers_toolbar_apply_button"
          />
        </div>
        {lockedFields.length ? (
          <p className="bulk_offers_field_note">
            {`Закреплено режимом: ${lockedFields.map((item) => item.label).join(', ')}.`}
          </p>
        ) : null}
        {field ? (
          <div className="bulk_offers_toolbar_apply_editor">
            <EventFieldEditor
              field={field}
              value={value}
              onChange={setValue}
              categories={categories}
              countries={countries}
              languages={languages}
              config={config}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default BulkToolbar;
